const referralTypes = {
  UnSet: 0,
  Initial: 1,
  Transfer: 4,
  Continuity: 14,
};

export default referralTypes;
